import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    strains: [],
    strainsLoading: false,
    strainsError: {},
    harvestSchedule: [],
    harvestScheduleLoading: false,
    harvestScheduleError: {},
    monthlyYieldPerformance: [],
    monthlyYieldPerformanceLoading: false,
    monthlyYieldPerformanceError: {},
    InFlightData: [],
    InFlightDataLoading: false,
    InFlightDataError: {},
}
const getters = {
    strains: (state) => state.strains,
    strainsLoading: (state) => state.strainsLoading,
    strainsError: (state) => state.strainsError,
    harvestSchedule: (state) => state.harvestSchedule,
    harvestScheduleLoading: (state) => state.harvestScheduleLoading,
    harvestScheduleError: (state) => state.harvestScheduleError,
    monthlyYieldPerformance: (state) => state.monthlyYieldPerformance,
    monthlyYieldPerformanceLoading: (state) => state.monthlyYieldPerformanceLoading,
    monthlyYieldPerformanceError: (state) => state.monthlyYieldPerformanceError,
    InFlightData: (state) => state.InFlightData,
    InFlightDataLoading: (state) => state.InFlightDataLoading,
    InFlightDataError: (state) => state.InFlightDataError
}

const mutations = {
    [types.GET_STRAINS_REQUEST] (state) {
        state.strainsLoading = true;
        state.strainsError = '';
        state.strains = [];
    },
    [types.GET_STRAINS_SUCCESS] (state, strains) {
        state.strainsLoading = false;
        state.strainsError = '';
        state.strains = strains;
    },
    [types.GET_STRAINS_FAILURE] (state, error) {
        state.strainsLoading = false;
        state.strainsError = error;
        state.strains = [];
    },
    [types.GET_HARVEST_SCHEDULE_REQUEST] (state) {
        state.harvestScheduleLoading = true;
        state.harvestScheduleError = '';
        state.harvestSchedule = [];
    },
    [types.GET_HARVEST_SCHEDULE_SUCCESS] (state, harvestSchedule) {
        state.harvestScheduleLoading = false;
        state.harvestScheduleError = '';
        state.harvestSchedule = harvestSchedule;
    },
    [types.GET_HARVEST_SCHEDULE_FAILURE] (state, error) {
        state.harvestScheduleLoading = false;
        state.harvestScheduleError = error;
        state.harvestSchedule = [];
    },
    [types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_REQUEST] (state) {
        state.monthlyYieldPerformanceLoading = true;
        state.monthlyYieldPerformanceError = '';
        state.monthlyYieldPerformance = [];
    },
    [types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_SUCCESS] (state, monthlyYieldPerformance) {
        state.monthlyYieldPerformanceLoading = false;
        state.monthlyYieldPerformanceError = '';
        state.monthlyYieldPerformance = monthlyYieldPerformance;
    },
    [types.GET_MONTHLY_TOTAL_YIELD_BY_STRAIN_FAILURE] (state, error) {
        state.monthlyYieldPerformanceLoading = false;
        state.monthlyYieldPerformanceError = error;
        state.monthlyYieldPerformance = [];
    },
    [types.GET_MONTHLY_TOTAL_YIELD_REQUEST] (state) {
        state.monthlyYieldPerformanceLoading = true;
        state.monthlyYieldPerformanceError = '';
        state.monthlyYieldPerformance = [];
    },
    [types.GET_MONTHLY_TOTAL_YIELD_SUCCESS] (state, monthlyYieldPerformance) {
        state.monthlyYieldPerformanceLoading = false;
        state.monthlyYieldPerformanceError = '';
        state.monthlyYieldPerformance = monthlyYieldPerformance;
    },
    [types.GET_MONTHLY_TOTAL_YIELD_FAILURE] (state, error) {
        state.monthlyYieldPerformanceLoading = false;
        state.monthlyYieldPerformanceError = error;
        state.monthlyYieldPerformance = [];
    },
    [types.GET_IN_FLIGHT_REQUEST] (state) {
        state.InFlightDataLoading = true;
        state.InFlightDataError = '';
        state.InFlightData = [];
    },
    [types.GET_IN_FLIGHT_SUCCESS] (state, InFlightData) {
        state.InFlightDataLoading = false;
        state.InFlightDataError = '';
        state.InFlightData = InFlightData;
    },
    [types.GET_IN_FLIGHT_FAILURE] (state, error) {
        state.InFlightDataLoading = false;
        state.InFlightDataError = error;
        state.InFlightData = [];
    }
}

export default{
    state,
    actions,
    getters,
    mutations
}
